var map = {
	"./chart_icon.svg": "3dd9",
	"./chart_icon_selected.svg": "2c90",
	"./chart_icon_selected_mobile.svg": "20ed",
	"./chat_icon.svg": "8eb4",
	"./chat_icon_selected.svg": "7871",
	"./chat_icon_selected_mobile.svg": "a275",
	"./email_icon.svg": "b94d",
	"./email_icon_selected.svg": "7f0f",
	"./email_icon_selected_mobile.svg": "885c",
	"./event_icon.svg": "d3f5",
	"./event_icon_selected.svg": "158a",
	"./event_icon_selected_mobile.svg": "6a70",
	"./help_icon.svg": "8969",
	"./help_icon_selected.svg": "ec33",
	"./help_icon_selected1.svg": "f5c8",
	"./help_icon_selected_mobile.svg": "a793",
	"./home_icon.svg": "90df",
	"./home_icon_selected.svg": "6510",
	"./home_icon_selected_mobile.svg": "8f0b",
	"./icon.png": "0ff8",
	"./icon.svg": "c092",
	"./locale-icon.svg": "705b",
	"./logout_icon.svg": "d213",
	"./multi_user.svg": "173d",
	"./multi_user_selected.svg": "f285",
	"./multi_user_selected_mobile.svg": "369c",
	"./setting_icon.svg": "ee12",
	"./setting_icon_selected.svg": "b7eb",
	"./setting_icon_selected_mobile.svg": "f9af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fce2";